
export default class MedikreditClaim {
    constructor() {
        this.id;
        this.providerId;
        this.accountId;
        this.patientId;
        this.patientName;
        this.patientSurname;
        this.patientIdentityNumber;
        this.providerPracticeNo;
        this.providerBhf;
        this.createdAt;
        this.isDeleted;
        this.medikreditClaimCsvId;
        this.medikreditClaimCsvName;
        this.medikreditClaimLines;
        this.mkclaimNumber;
        this.memberAccountNumber;
        this.memberId;

    }

    set(setEntity) {
        this.id = setEntity.id;
        this.providerId = setEntity.providerId;
        this.accountId = setEntity.accountId;
        this.patientId = setEntity.patientId;
        this.patientName = setEntity.patientName;
        this.patientSurname = setEntity.patientSurname;
        this.patientIdentityNumber = setEntity.patientIdentityNumber;
        this.providerPracticeNo = setEntity.providerPracticeNo;
        this.providerBhf = setEntity.providerBhf;
        this.createdAt = setEntity.createdAt;
        this.isDeleted = setEntity.isDeleted;
        this.medikreditClaimCsvId = setEntity.medikreditClaimCsvId;
        this.medikreditClaimCsvName = setEntity.medikreditClaimCsvName;
        this.medikreditClaimLines = setEntity.medikreditClaimLines;
        this.mkclaimNumber = setEntity.mkclaimNumber;
        this.memberAccountNumber = setEntity.memberAccountNumber;
        this.memberId = setEntity.memberId;
        return this;
    }
}